import { render, staticRenderFns } from "./Receive.vue?vue&type=template&id=65b10688&scoped=true"
import script from "./Receive.vue?vue&type=script&lang=js"
export * from "./Receive.vue?vue&type=script&lang=js"
import style0 from "./Receive.vue?vue&type=style&index=0&id=65b10688&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b10688",
  null
  
)

export default component.exports